module.exports = __webpack_public_path__ + "static/media/shaff1109.e6018f8d.jpg";